import type { Dictionnaire } from '../type';
import { compte } from './pluriel';

export const moderation: Dictionnaire['moderation'] = {
  erreurs: {
    compteOfficiel: 'لا يمكن الإبلاغ عن حساب التطبيق. راسله بأي سؤال.',
  },
  contenu: {
    supprime: '(محتوى محذوف)',
    sansTexte: '(بلا نص)',
  },
  merci: {
    emailParti: 'إذا كان الحساب موجودًا، فالرسالة في طريقها.',
    post: 'شكرًا، سيتولى فريقنا الأمر. لن ترى هذا المنشور بعد الآن.',
    signalement: 'تم إرسال البلاغ. شكرًا، سنتولى الأمر.',
    sortie: 'شكرًا، سيتولى فريقنا الأمر. لن ترى هذه الفعالية بعد الآن.',
    simple: 'شكرًا، سيتولى فريقنا الأمر.',
    membre: 'شكرًا، سيتولى فريقنا الأمر. هذا العضو محظور في الأثناء.',
    support: 'تم إرسال الرسالة. سيردّ فريقنا عبر البريد الإلكتروني.',
  },
  raisons: {
    spam: 'رسائل مزعجة',
    harassment: 'تحرّش',
    shocking: 'محتوى صادم',
    misinformation: 'معلومات كاذبة',
    other: 'أخرى',
  },
  admin: {
    durees: {
      jour: '24 ساعة',
      semaine: '7 أيام',
      mois: '30 يومًا',
      sansTerme: 'بلا مدة محدّدة',
    },
    echec: 'لم ينجح ذلك.',
    fait: (geste: string) => `${geste}: تمّ.`,
    gestes: {
      avertir: 'تحذير',
      liberer: 'إعادة حق الكلام',
      museler: 'كتم',
      retablir: 'استعادة الحساب',
      suspendre: 'تعليق الحساب',
      suspendreQ: 'تعليق هذا الحساب؟',
      retirerCoche: 'إزالة الشارة',
      poserCoche: 'إضافة الشارة',
      nommerModerateur: 'تعيينه مشرفًا للمحتوى',
      nommerAdmin: 'تعيينه مديرًا',
      retirerRole: 'سحب الدور',
      supprimer: 'حذف الحساب',
      supprimerQ: 'محو هذا الحساب وكل ما كتبه؟ لا شيء سيعيده.',
    },
    titre: 'الإدارة',
    chercherMembre: 'البحث عن عضو',
    sonPseudo: 'اسم المستخدم',
    chercher: 'بحث',
    personne: 'لا أحد بهذا الاسم',
    autre: '→ البحث عن شخص آخر',
    rien: 'لا شيء يُذكر',
    avertissements: 'التحذيرات',
    texteMembre: 'ما سيقرؤه العضو',
    pourquoi: 'السبب (يُحفظ في السجل)',
    etat: {
      administrateur: 'مدير',
      moderateur: 'مشرف محتوى',
      verifie: 'موثّق',
      suspendu: 'معلّق',
      muetJusqua: (date: string) => `مكتوم حتى ${date}`,
      muet: 'مكتوم، بلا مدة',
      signalements: (n: number) => compte(n, 'بلاغ واحد', 'بلاغان', 'بلاغات', 'بلاغًا'),
      avertissements: (n: number) => compte(n, 'تحذير واحد', 'تحذيران', 'تحذيرات', 'تحذيرًا'),
      lu: 'مقروء',
      pasLu: 'لم يُقرأ بعد',
    },
  },
  avertissement: {
    titre: 'تحذير',
    compris: 'فهمت',
  },
  file: {
    onglets: {
      ouverts: 'للمعالجة',
      traites: 'معالَجة',
      tout: 'الكل',
    },
    natures: {
      post: 'منشور',
      comment: 'تعليق',
      event: 'فعالية',
      user: 'عضو',
      conversation: 'محادثة',
      help: 'رسالة مساعدة',
    },
    masque: 'أُخفي المحتوى.',
    suspendu: 'عُلّق العضو.',
    classe: 'أُغلق البلاغ.',
    titre: 'الإشراف',
    masquer: 'إخفاء المحتوى',
    suspendre: 'تعليق العضو',
    classer: 'إغلاق دون إجراء',
    rienATraiter: 'لا شيء للمعالجة',
    rienIci: 'لا شيء هنا',
    aucunEnAttente: 'لا توجد بلاغات معلّقة. هذه علامة جيدة.',
    traitesIci: 'ستظهر البلاغات المعالَجة هنا.',
    etatMasque: 'المحتوى مخفي',
    etatSuspendu: 'العضو معلّق',
    etatClasse: 'أُغلق دون إجراء',
    traiter: 'معالجة',
    suspendreQ: (nom: string) => `تعليق ${nom}؟ يُقطع وصوله حتى تتم استعادته.`,
    signalements: (n: number) => compte(n, 'بلاغ واحد', 'بلاغان', 'بلاغات', 'بلاغًا'),
    signalePar: (nom: string) => `أبلغ عنه ${nom}`,
  },
  signaler: {
    quoi: {
      post: 'هذا المنشور',
      comment: 'هذا الردّ',
      event: 'هذه الفعالية',
      member: 'هذا العضو',
      conversation: 'هذه المحادثة',
    },
    impossible: 'تعذّر الإرسال الآن.',
    titre: 'إبلاغ',
    indisponible: 'هذا المحتوى لم يعد متاحًا.',
    envoyer: 'إرسال',
    motif: 'ما السبب؟',
    detail: 'أضف تفاصيل إن أردت',
    detailExemple: 'اختياري: ما الذي حدث، ومنذ متى.',
    intro: (quoi: string) => `أخبرنا بما لا يناسب في ${quoi}. يراجع فريقنا كل بلاغ، ولا يُبلَّغ الشخص المعني.`,
  },
};
